export function getLast7Days() {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(endDate.getDate() - 6); // Last 7 days including today
  return { startDate, endDate };
}

export function getLast30Days() {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(endDate.getDate() - 29); // Last 30 days including today
  return { startDate, endDate };
}

export function getLastYear() {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setFullYear(endDate.getFullYear() - 1);
  startDate.setDate(endDate.getDate() + 1); // Start from tomorrow last year to include today in the range
  return { startDate, endDate };
}

export function getAllTime() {
  // Assuming 'null' signifies no filtering by date, adjust based on your API's requirements
  return { startDate: null, endDate: null };
}
